import { Directive, ElementRef, HostListener } from '@angular/core';
import { scrollInvalidControl } from '../../shared/scroll';

@Directive({
  selector: '[appSubmitScrollInvalidControl]'
})
export class SubmitScrollInvalidControlDirective {

  constructor(private el: ElementRef) { }

  @HostListener('ngSubmit')
  onSubmit() {
    scrollInvalidControl(this.el.nativeElement);
  }
}
